import { useNavigate } from "react-router-dom";
import { useSelectRealmMutation, useGetUserRealmsQuery, useGetUserDataQuery } from "services/users"
import styled from "styled-components"
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";


export type UserRealm = {
    id: string;
    name: string;
}


export const RealmSelector = () => {
    const { data: realmsData, isLoading: realmsLoading } = useGetUserRealmsQuery(undefined);
    const [selectRealm, { isLoading: selectingRealm }] = useSelectRealmMutation();
    const { refetch: refetchUserData } = useGetUserDataQuery(undefined);
    const navigate = useNavigate();
    const { t } = useTranslation('auth');

    const handleRealmSelect = async (realmId: string) => {
        try {
            await selectRealm({ realm_id: realmId }).unwrap();
            await refetchUserData();
            navigate("/backoffice/");
        } catch (error) {
            toast.error(t("failedToSelectRealm") as string);
        }
    }

    if (realmsLoading) {
        return <div>{t("loadingRealms")}</div>;
    }

    return (
        <Container>
            <h2>{t("selectRealm")}</h2>
            {realmsData && realmsData.length > 0 ? (
                <RealmList>
                    {realmsData.map((realm: any) => (
                        <RealmItem key={realm.id} onClick={() => handleRealmSelect(realm.id)}>
                            {realm.name}
                        </RealmItem>
                    ))}
                </RealmList>
            ) : (
                <div>{t("noRealmsAvailable")}</div>
            )}
            {selectingRealm && <div>{t("selectingRealm")}</div>}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const RealmList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
`;

const RealmItem = styled.div`
    padding: 10px 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f0f0f0;
    }
`;

